import { render, staticRenderFns } from "./StaysGroup.vue?vue&type=template&id=4cf5e335&scoped=true"
import script from "./StaysGroup.vue?vue&type=script&lang=js"
export * from "./StaysGroup.vue?vue&type=script&lang=js"
import style0 from "./StaysGroup.vue?vue&type=style&index=0&id=4cf5e335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5e335",
  null
  
)

export default component.exports